import { createColumnHelper } from "@tanstack/react-table";
import { IconButton, Tooltip } from "@mui/material";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { formatDateWithoutTime } from "utils";

const columnHelper = createColumnHelper();

const IVersiones = ({ downloadFile } : any) => {
    return [
        columnHelper.accessor("version", {
            header: () => "Versión",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("fechaCarga", {
            header: () => "Fecha de carga",
            cell: (info) =>  formatDateWithoutTime(info.getValue()),
        }),
        columnHelper.accessor("accions", {
            header: () => "",
            cell: ({row}) => (
                <Tooltip onClick={() => downloadFile(row.original)} title="Descargar">
                    <IconButton>
                        <DownloadForOfflineIcon />
                    </IconButton>
                </Tooltip>
            )
        }),
    ];
};

export default IVersiones;
